export default {"src":"/_next/static/image/public/images/ic_order_clock_chocolate.596a13bb27b5ab487ab7dc8a8981e97d.svg","height":17,"width":17};